import React, { useState, useRef } from 'react';
import Modal from '../../Atoms/Modal/Modal';
import uploadIcon from '../../../assets/Imagess/upload-icon.svg';
import styles from '../../Atoms/Modal/Modal.module.scss';
import Buttons from '../../Atoms/Buttons/Buttons';
import calendarIcon from '../../../assets/Imagess/calendar-icon.svg';
import { useMutation } from 'react-query';
import { API_URL } from '../../../Constants';
import axios from 'axios';
import CustomSelect from '../../Atoms/forms/customSelect/CustomSelect';
import { useFetchAcademicYears } from '../../../Hooks/Settings';
import { useToast } from '../Custom/CustomToaster/Toast';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import CustomizedSelect from '../../Atoms/Inputs/CustomizedSelect';
import fileIcon from '../../../assets/Imagess/file-icon-green.svg';
import closeIcon from '../../../assets/Imagess/close2.svg';
import LoaderButton from '../Loader/LoaderButton';
import { toast } from 'react-toastify';

const UploadPosterModal = ({
  handleOnClose,
  refetch,
  type,
  AddCalendarPoster,
  isLoading,
  selectedYear,
}) => {
  const fileInputRef = useRef(null);
  const { data: academicYears } = useFetchAcademicYears();
  const customizedToast = useToast();

  const UploadPosterValidationSchema = Yup.object().shape({
    image: Yup.mixed().required('ملف صورة مطلوب'),
  });

  const handleUploadImageClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Formik
      initialValues={{ academicYear: '', image: null }}
      validationSchema={UploadPosterValidationSchema}
      onSubmit={(values) => {
        var formData = new FormData();
        formData.append(
          'CalendarPosterId',
          '00000000-0000-0000-0000-000000000000'
        );
        formData.append('AcademicYearId', selectedYear);
        formData.append('CalendarType', type);
        formData.append('Poster', values.image);

        AddCalendarPoster(formData, {
          onSuccess: () => {
            refetch();
            handleOnClose();
            customizedToast.open('تم تحميل الملصق بنجاح');
          },
        });
      }}
    >
      {({ setFieldValue, errors, touched, values, handleSubmit }) => {
        const handleFileChange = (event) => {
          const file = event.currentTarget.files[0];
          if (file && file.type === 'application/pdf') {
            setFieldValue('image', file);
          } else {
            setFieldValue('image', null);
            toast.error('يرجى تحميل ملف PDF صالح.');
          }
        };
        return (
          <Form>
            <Modal
              onClose={handleOnClose}
              width='700px'
              closeWhite={false}
              title='رفع الملصق'
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '17px',
                  paddingTop: '10px',
                }}
              >
                {/* <CustomSelect
                  label='اختر السنة'
                  placeholder='اختر السنة'
                  name='academicYear'
                  icon={calendarIcon}
                  value={values.academicYear}
                  onChange={(name, value) => {
                    setFieldValue(name, value);
                  }}
                  options={academicYears?.data?.map((option) => ({
                    value: option.acadamicYearId,
                    text: option.academicName,
                  }))}
                  errors={errors.academicYear}
                  touched={touched.academicYear}
                  right
                /> */}
                {errors.image && touched.image ? (
                  <p style={{ color: 'red' }}>يرجى اختيار ملف للتحميل</p>
                ) : (
                  ''
                )}

                <Field name='image'>
                  {({ field }) =>
                    field.value ? (
                      <div className={styles['uploaded-item-container']}>
                        <div className={styles['file-name-container']}>
                          <img src={fileIcon} />
                          <p className={styles['file-name']}>
                            {field.value.name ? field.value.name : field.value}
                          </p>
                        </div>
                        <img
                          style={{ cursor: 'pointer' }}
                          src={closeIcon}
                          onClick={() => setFieldValue('image', null)}
                        />{' '}
                      </div>
                    ) : (
                      <div
                        className={styles['upload-container']}
                        onClick={handleUploadImageClick}
                      >
                        <div className={styles['upload-icon-container']}>
                          <img
                            className={styles['upload-icon']}
                            src={uploadIcon}
                          />
                          <div className={styles['text-container']}>
                            <p className={styles['select-image']}>
                              اختر ملف للتحميل
                            </p>
                            <p className={styles['size']}>
                              الحد الأقصى للحجم: <span dir='ltr'>100 MB</span>{' '}
                            </p>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </Field>
                {isLoading ? (
                  <LoaderButton />
                ) : (
                  <Buttons
                    text='حفظ'
                    color='#0DA06E'
                    rounded={true}
                    style={{ width: '100%', fontFamily: 'BukraBold' }}
                    type='submit'
                    handleOnClick={handleSubmit}
                  />
                )}
              </div>
              <input
                type='file'
                className='form-control form-body-input'
                style={{ display: 'none' }}
                ref={fileInputRef}
                accept='application/pdf'
                onChange={handleFileChange}
                multiple
                required
              />
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default UploadPosterModal;
